export default {

  data() {
    return {
      infiniteLoadIsInitiated: false,
      infiniteLoadObserver: null,
      observedNodes: new Set(),
    };
  },

  methods: {
    initInfiniteLoad(targetNode, options = {root: null, rootMargin: '0px', threshold: 1.0}) {
      if (this.observedNodes.has(targetNode)) return;

      let callback = (entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            this.$emit('onInfiniteLoad');
            if(typeof this.onInfiniteLoad === 'function') {
              this.onInfiniteLoad(entry, targetNode);
            }
          }
        });
      };

      this.infiniteLoadObserver = new IntersectionObserver(callback, options);
      this.infiniteLoadObserver.observe(targetNode);
      this.observedNodes.add(targetNode);
      this.infiniteLoadIsInitiated = true;
      // if(this.infiniteLoadObserver.root) this.infiniteLoadObserver.root.style.border = "2px solid #44aa44";
    },

    infiniteLoadDisconnect(reset = true) {
      if(reset) this.infiniteLoadIsInitiated = false;
      if(this.infiniteLoadObserver) {
        this.infiniteLoadObserver.disconnect();
        this.observedNodes.clear();
      }
    },

    infiniteLoadUnobserve(targetNode, reset = true) {
      if(reset) this.infiniteLoadIsInitiated = false;
      if(this.infiniteLoadObserver) {
        this.infiniteLoadObserver.unobserve(targetNode);
        this.observedNodes.delete(targetNode);
      }
    }
  },

  beforeUnmount() {
    if(this.infiniteLoadObserver) this.infiniteLoadDisconnect(); // Cleanup observer
  },
}